import StyledHeading from '/shared/styled/components/StyledHeading';
import StyledParagraph from '/shared/styled/components/StyledParagraph';
import StyledHorizontalRule from '/shared/styled/components/StyledHorizontalRule';

const ElectricityHeatSteamEmissionsDisplay = () => (
  <>
    <StyledHorizontalRule />
    <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
      How your electricity, heat and steam emissions are displayed
    </StyledHeading>
    <StyledParagraph $largeText>
      In line with the GHG Protocol Scope 2 Guidance, the CMP applies a <b>dual-reporting</b> approach and calculates
      your purchased <b>electricity, heat and steam emissions</b> using two methods:
    </StyledParagraph>
    <ul>
      <li>
        <StyledParagraph $largeText>
          <b>Market-based</b>
          <br />
          This method calculates emissions based on the specific power or heating options your business has chosen to
          buy. It factors in things like "green power" plans, clean heating programs, and Energy Attribute Certificates
          (EACs) that your business specifically purchases to prove its energy comes from renewable sources.
        </StyledParagraph>
      </li>
      <li>
        <StyledParagraph $largeText>
          <b>Location-based</b>
          <br />
          This method calculates emissions based on the average pollution level of the local power grid or heating
          network connected to your business's physical buildings. It ignores any specific energy plans or EACs your
          business pays for, focusing instead on the actual energy mix flowing through the local lines.
        </StyledParagraph>
      </li>
    </ul>
    <StyledParagraph $largeText>
      <b>By default, the CMP displays your market-based result for electricity, heat and steam.</b>
    </StyledParagraph>
    <StyledParagraph $largeText>
      When there is no market-based data available, we default to the location-based data for that calculation. Every
      unit of <b>energy is only ever counted once</b>, regardless of which approach was used.
    </StyledParagraph>
    <StyledParagraph $largeText>
      <b>
        Your downloadable carbon emissions report (XLSX) always displays market-based and location-based calculations
      </b>{' '}
      for electricity, heat, and steam. This allows you to easily review, compare, and report both methods as required
      by any framework you follow.
    </StyledParagraph>
  </>
);

export default ElectricityHeatSteamEmissionsDisplay;
